import React from 'react';
import { Table, Icon } from 'antd';
// import TablePageSize from './TablePageSize';

const placeholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const DocumentTable = props => {
  const {
    document,
    // pages,
    onChangeTable,
    // changePaginationSize,
    renderColumns,
    documentLoading,
    handleClickRow,
    onChangeRowSelection,
  } = props;

  const rowSelection = {
    onChange: selectedRowKeys => {
      onChangeRowSelection(selectedRowKeys);
    },
  };
  return (
    <div className="orders__table">
      <Table
        locale={{
          emptyText: documentLoading ? placeholder : 'Документов нет...',
        }}
        columns={renderColumns()}
        dataSource={document}
        rowKey="id"
        pagination={false}
        onRow={handleClickRow}
        onChange={onChangeTable}
        rowSelection={rowSelection}
      />
    </div>
  );
};

export default DocumentTable;
